module.exports = __webpack_public_path__ + "img/icons-add-beneficiary.ff5d4f0c.svg";